// Read-only multi-line render of a structured address.
// Skips empty fields. Joins City + Province on one line and Post Code + Country on another.
//
// Value shape: { line1, line2, city, province, postCode, country }

function joinNonEmpty(parts, separator) {
  return parts.filter((p) => typeof p === 'string' && p.trim() !== '').join(separator);
}

export function AddressDisplay({ value, className, emptyFallback = null }) {
  if (!value || typeof value !== 'object') return emptyFallback;

  const line1 = (value.line1 || '').trim();
  const line2 = (value.line2 || '').trim();
  const cityProvince = joinNonEmpty([value.city, value.province], ', ');
  const postCountry  = joinNonEmpty([value.postCode, value.country], ', ');

  const lines = [line1, line2, cityProvince, postCountry].filter(Boolean);
  if (lines.length === 0) return emptyFallback;

  return (
    <address className={'address-display' + (className ? ` ${className}` : '')}>
      {lines.map((line, i) => (
        <div key={i} className="address-display__line">{line}</div>
      ))}
    </address>
  );
}
